import { useState, useEffect, useCallback } from "react";
import ApiService from "../api/apiService";

const STORAGE_KEY = "buildhub_ai_tasks";

function loadTasks() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function useAITasks() {
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const _apiTasks = await ApiService.tasks.getMyTasks();
        if (_apiTasks && _apiTasks.success) {
          const apiTasks = _apiTasks.data.map((t) => {
            return {
              id: t.id,
              conversation: { ...t.conversation },
              message: { ...t.message },
              requester: {
                id: t.requester_id,
              },
              title: t.title,
              description: t.description,
              priority: t.priority,
              createdAt: t.createdAt,
              dueDate: t.dueDate,
            };
          });
          setTasks(apiTasks);
        }
      } catch {}
    };

    fetchTasks();
    const interval = setInterval(fetchTasks, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const toggleTask = useCallback((id) => {
    setTasks((prev) =>
      prev.map((t) => (t.id === id ? { ...t, isDone: !t.isDone } : t)),
    );
  }, []);

  const pendingCount = tasks.length;

  return { tasks, toggleTask, pendingCount };
}
